// Fragment "lib (lot O)" — erreurs des intégrations Google partagées (GoogleLoginButton,
// useGoogleDrivePicker), consommées via useT("common") côté composants et lookup()
// direct côté code non-React (voir lib/ErrorBoundary.jsx pour le précédent).
export default {
  fr: {
    "googleAuth.configMissing": "Configuration Google manquante (REACT_APP_GOOGLE_CLIENT_ID).",
    "googleAuth.scriptLoadFailed": "Échec du chargement de Google Identity Services",
    "googleAuth.signInFailed": "Échec de la connexion. Veuillez réessayer.",
    "googleAuth.loadFailed": "Impossible de charger Google Sign-In.",
    "googleAuth.continueWithGoogle": "Continuer avec Google",
    "googleAuth.signingIn": "Connexion en cours…",
    "googleAuth.popupBlocked": "La fenêtre Google n'a pas pu s'ouvrir. Autorisez les fenêtres pop-up, puis réessayez.",
    "googleDrivePicker.notReady": "Google Picker non prêt",
    "googleDrivePicker.scriptLoadFailed": "Échec du chargement de {src}",
  },
  en: {
    "googleAuth.configMissing": "Missing Google configuration (REACT_APP_GOOGLE_CLIENT_ID).",
    "googleAuth.scriptLoadFailed": "Failed to load Google Identity Services",
    "googleAuth.signInFailed": "Sign-in failed. Please try again.",
    "googleAuth.loadFailed": "Unable to load Google Sign-In.",
    "googleAuth.continueWithGoogle": "Continue with Google",
    "googleAuth.signingIn": "Signing you in…",
    "googleAuth.popupBlocked": "The Google window could not open. Allow pop-ups, then try again.",
    "googleDrivePicker.notReady": "Google Picker not ready",
    "googleDrivePicker.scriptLoadFailed": "Failed to load {src}",
  },
  es: {
    "googleAuth.configMissing": "Falta la configuración de Google (REACT_APP_GOOGLE_CLIENT_ID).",
    "googleAuth.scriptLoadFailed": "Error al cargar Google Identity Services",
    "googleAuth.signInFailed": "Error al iniciar sesión. Inténtalo de nuevo.",
    "googleAuth.loadFailed": "No se pudo cargar Google Sign-In.",
    "googleAuth.continueWithGoogle": "Continuar con Google",
    "googleAuth.signingIn": "Conectando…",
    "googleAuth.popupBlocked": "No se pudo abrir la ventana de Google. Permite las ventanas emergentes e inténtalo de nuevo.",
    "googleDrivePicker.notReady": "Google Picker no está listo",
    "googleDrivePicker.scriptLoadFailed": "Error al cargar {src}",
  },
};
